import { QRCodeSVG } from "qrcode.react";
import React from "react";
import H2 from "../H2";
import { replaceWithDataSource } from "../helpers/variable";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { useSelector } from "react-redux";

export default function QR({ cue, cloud, baseTheme, baseThemeId }) {
	const { projectId } = useParams();
	const dynamicText = useSelector(
		(state) => state.main?.projects?.[projectId]?.dynamicText
	);
	const dynamicLists = useSelector(
		(state) => state.main?.projects?.[projectId]?.dynamicLists
	);
	return (
		<div className="flex items-center justify-center space-x-4">
			<div
				className={`m-s2 flex flex-col items-center
                    ${cue.message ? "space-y-4" : "space-y-0"}
                        `}
			>
				<QRCodeSVG
					value={replaceWithDataSource(cue.url, dynamicText, dynamicLists, false)}
					style={{
						height: `12vw`,
						width: `12vw`,
						aspectRatio: `1/1`,
						padding: ".5vw",
						backgroundColor: cue.bgColour || "white",
					}}
					bgColor={cue.bgColour || "white"}
					fgColor={cue.fgColour || "black"}
				/>

				<H2
					cue={cue}
					text={cue.message}
					baseTheme={baseTheme}
					baseThemeId={baseThemeId}
				/>
			</div>
		</div>
	);
}
